const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

function pad(value) {
  return String(Math.max(value, 0)).padStart(2, '0');
}

function tick(el) {
  const end = new Date(el.dataset.end).getTime();

  if (Number.isNaN(end)) {
    el.hidden = true;
    return;
  }

  const remaining = end - Date.now();

  const days = Math.floor(remaining / DAY);
  const hours = Math.floor((remaining % DAY) / HOUR);
  const minutes = Math.floor((remaining % HOUR) / MINUTE);
  const seconds = Math.floor((remaining % MINUTE) / SECOND);

  el.querySelector('[data-countdown-days]').textContent = pad(days);
  el.querySelector('[data-countdown-hours]').textContent = pad(hours);
  el.querySelector('[data-countdown-minutes]').textContent = pad(minutes);
  el.querySelector('[data-countdown-seconds]').textContent = pad(seconds);

  if (remaining <= 0) {
    clearInterval(el._countdownInterval);
    el.dispatchEvent(new CustomEvent('countdown:complete', { bubbles: true }));
  }
}

function init(el) {
  if (el.dataset.countdownInitialized) return;
  el.dataset.countdownInitialized = 'true';

  tick(el);
  el._countdownInterval = setInterval(() => tick(el), SECOND);
}

function initAll() {
  document.querySelectorAll('[data-countdown-timer]').forEach(init);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

document.addEventListener('shopify:section:load', initAll);
